export const GET_CHALLENGE_DETAILS = 'GET_CHALLENGE_DETAILS'
export const GET_CHALLENGE_DETAILS_ERROR = 'GET_CHALLENGE_DETAILS_ERROR'
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS'
export const USER_LOGOUT = 'USER_LOGOUT'
export const GET_CHECKIN_COUNT = 'GET_CHECKIN_COUNT'
export const GET_CHECKIN_COUNT_ERROR = 'GET_CHECKIN_COUNT_ERROR'
export const SHOW_SUBMIT_STATS_FORM = 'SHOW_SUBMIT_STATS_FORM'
export const UPDATE_AUTH = 'UPDATE_AUTH'
export const UPDATE_CHALLENGE_PROGRESS = 'UPDATE_CHALLENGE_PROGRESS'
export const UPDATE_CHALLENGE_PROGRESS_ERROR = 'UPDATE_CHALLENGE_PROGRESS_ERROR'
